<template>
    <Head :title="'Utilisateur N°'+ userShow.code" />

    <UserLayout :userShow="userShow" :roles="roles" :currency="currency">
        <div x-data="handleSelect">
            <Datatables>
                <template #title>
                    Liste des colis
                    <span class="font-medium">({{ packages.total }})</span>
                </template>
                <template #headerButtons>
                    <button class="rounded-md py-1 px-2 bg-white text-sky hover:bg-sky-400 hover:text-white"
                        @click="showSearchModal" title="Rechercher"
                    ><i class="fad fa-search"></i>
                    </button>
                </template>
                <template #tableHeader>
                    <th>#</th>
                    <th>Code</th>
                    <th>Destinataire</th>
                    <th>Nombre de colis</th>
                    <th>Montant</th>
                    <th>Statut Colis</th>
                    <th>Statut Facture</th>
                    <th>&nbsp;</th>
                </template>
                <template #tableBody>
                    <template v-if="!packages.data.length">
                        <tr>
                            <td colspan="8">
                                <div class="text-center text-2xl text-red-400 bg-red-100 p-10">
                                    <b>{{ userShow.name }}</b> n'a encore effectué aucun envoie de colis pour le moment.
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else v-for="(pack, index) in packages.data" :key="pack.id">
                        <tr>
                            <td>{{ index + 1 }}</td>
                            <td>
                                <div class="grow text-left">
                                    <h2 class="font-bold text-sky inline-flex">{{ pack.code }}</h2>
                                    <div class="text-xs text-gray-500">
                                        Enregistré le <span class="capitalize">{{ formattedDate(pack.created_at) }}</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="grow text-left">
                                    <h2 class="font-semibold text-gray-800 inline-flex">{{ pack.receiver_name ?? 'Non renseigné' }}</h2>
                                    <div :class="'text-xs text-gray-500'+ (pack.receiver_phone ? ' font-semibold' : '')">
                                        {{ pack.receiver_phone ? pack.receiver_full_phone : 'Non renseigné' }}
                                    </div>
                                </div>
                            </td>
                            <td>{{ pack.weight ?? 'Non renseigné' }}</td>
                            <td>
                                <div class="text-right font-bold"
                                    :class="pack.invoice.balance > 0 ? 'text-gray-400': 'text-greendack-500'"
                                >{{ formatAmount(pack.amount, currency) }}
                                </div>
                            </td>
                            <td><StatusBadge :label="pack.status_text" :color="pack.status_color" /></td>
                            <td><StatusBadge :label="pack.invoice.status_text" :color="pack.invoice.status_color" /></td>
                            <td>
                                <Link class="flex justify-end" title="Détails"
                                    :href="route('travels.packages.index', pack.travel) + '?filter[code]=' + pack.code"
                                >
                                    <svg class="shrink-0 h-6 w-6" viewBox="0 0 24 24">
                                        <path class="fill-current text-sky" d="M8.07 16H10V8H8.07a8 8 0 110 8z"></path>
                                        <path class="fill-current text-sky-300" d="M15 12L8 6v5H0v2h8v5z"></path>
                                    </svg>
                                </Link>
                            </td>
                        </tr>
                    </template>
                </template>
            </Datatables>
        </div>

        <Pagination :links="packages.links" />

        <jet-dialog-modal :show="searchModal" @close="closeSearchModal" max-width="xl">
            <template #title>Rechercher un colis</template>
            <template #content>
                <GlobalFilter @search-launched="closeSearchModal" />
            </template>
        </jet-dialog-modal>
    </UserLayout>
</template>

<script>
    import { defineComponent } from 'vue'
    import Pagination from '@/Components/Pagination'
    import Datatables from '@/Components/Datatables'
    import UserLayout from '@/Layouts/UserLayout.vue'
    import StatusBadge from '@/Components/StatusBadge'
    import JetDialogModal from '@/Jetstream/DialogModal'
    import GlobalFilter from '@/Components/GlobalFilter'
    import CurrencyMixins from '@/Mixins/CurrencyMixins'
    import { Head, Link } from '@inertiajs/inertia-vue3';
    import DateFormatMixins from '@/Mixins/DateFormatMixins'
    import SearchActionMixins from '@/Mixins/SearchActionMixins'

    export default defineComponent({
        components: {
            Head,
            Link,
            UserLayout,
            Pagination,
            Datatables,
            StatusBadge,
            GlobalFilter,
            JetDialogModal
        },

        mixins: [ CurrencyMixins, SearchActionMixins, DateFormatMixins],

        props: {
            roles: Array,
            userShow: Object,
            currency: Object,
            packages: Object
        }
    })
</script>

